import React from 'react';
import { Box, LinearProgress, Tooltip,Typography } from '@mui/material';

interface ConfidenceMeterProps {
  confidence: number; // 0-1 scale
  showLabel?: boolean;
  size?: 'small' | 'medium';
}

export const ConfidenceMeter: React.FC<ConfidenceMeterProps> = ({
  confidence,
  showLabel = true,
  size = 'small',
}) => {
  const percentage = Math.round(confidence * 100);

  // Color based on confidence level
  const getColor = () => {
    if (confidence >= 0.8) return 'success';
    if (confidence >= 0.5) return 'warning';
    return 'error';
  };

  const height = size === 'small' ? 6 : 8;

  return (
    <Tooltip title={`${percentage}% confidence`} arrow>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 100 }}>
        {showLabel && (
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              minWidth: 35,
              color: 'text.secondary',
              fontSize: size === 'small' ? '0.7rem' : '0.75rem',
            }}
          >
            {percentage}%
          </Typography>
        )}
        <Box sx={{ flex: 1, minWidth: 60 }}>
          <LinearProgress
            variant="determinate"
            value={percentage}
            color={getColor()}
            sx={{
              height,
              borderRadius: 1,
              bgcolor: 'rgba(0, 0, 0, 0.08)',
            }}
          />
        </Box>
      </Box>
    </Tooltip>
  );
};
